import React from 'react';
import { Icon, Spinner } from 'ui';

const ActionBarStatus = ({
  type,
  bulkDone,
  hasError,
  bulkCount,
  bulkInProgress,
}) => {
  const renderBulkDone = () => (
    <div className="Index-success">
      <Icon name="completed" className="Index-toolbarStateIcon" />
      {t('mass_actions.restore.success_with_type', { type, count: bulkCount })}
    </div>
  );

  const renderFail = () => (
    <div className="Index-fail">
      <Icon name="info" className="Index-toolbarStateIcon" />
      <span>{t('mass_actions.failed')}</span>
    </div>
  );

  const renderLoading = () => {
    return (
      <div className="Index-loading">
        <Spinner />
        <span className="ml-8">
          {t('mass_actions.restore.restoring_with_type', {
            type,
            count: bulkCount,
          })}
        </span>
      </div>
    );
  };

  const render = () => {
    if (hasError) return renderFail();
    if (bulkInProgress && !bulkDone) return renderLoading();
    if (bulkDone) return renderBulkDone();
    return null;
  };

  return <div>{render()}</div>;
};

export default ActionBarStatus;
